<i18n src="@/locales/models/exported_batch.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/harvested_batch.yml" lang="yaml"></i18n>

<template>
  <div class="mt-8">
    <div class="panel">
      <div class="panel-header">
        <h3 class="panel-header-title">
          {{ $t("model.exported_batch._self") }}
        </h3>
      </div>
      <div class="panel-body">
        <div class="space-y-8 divide-y divide-slate-200">
          <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.harvested_batch.week") }}
              </dt>
              <dd class="content-data">
                {{ exported_batch.week }}
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.harvested_batch.registered_at") }}
              </dt>
              <dd class="content-data">
                {{ dateFormatter(exported_batch.registered_at) }}
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.exported_batch.batch_code") }}
              </dt>
              <dd class="content-data">
                {{ exported_batch.batch_code }}
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.exported_batch.producer") }}
              </dt>
              <dd class="content-data">
                {{ exported_batch.producer.producer_org_code }} -
                {{ exported_batch.producer.producer_code }} -
                {{ exported_batch.producer.fullname }}
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.exported_batch.crop_field") }}
              </dt>
              <dd class="content-data">
                {{ exported_batch.crop_field?.name }}
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.exported_batch.total_amount") }}
              </dt>
              <dd class="content-data">
                {{ numberWithPrecision(exported_batch.total_amount) }} Kg
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.exported_batch.agro_exporter") }}
              </dt>
              <dd class="content-data">
                {{ exported_batch.agro_exporter_process?.name }} -
                {{ exported_batch.agro_exporter_process.agro_exporter?.name }}
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.exported_batch.packing_house") }}
              </dt>
              <dd class="content-data">
                {{ exported_batch.packing_house_process?.name }} -
                {{ exported_batch.packing_house_process.packing_house?.name }}
              </dd>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrgProcessHarvestExportExportedBatchInfo",
  data() {
    return {};
  },
  props: {
    exported_batch: {
      type: Object,
      required: true
    }
  }
};
</script>
